import { useEffect } from 'react';
import { LoginForm } from '@/features/auth';
import { useTheme } from '@/features/theme/contexts/ThemeContext';
import { VersionBadge } from '@/components/ui/version-badge';

export function LoginPage() {
  const { theme, setTheme } = useTheme();

  // Ensure dark mode on login page
  useEffect(() => {
    if (theme !== 'dark') {
      setTheme('dark');
    }
  }, [theme, setTheme]);

  return (
    <div data-slot="login-page">
      <LoginForm />
      <VersionBadge />
    </div>
  );
}